import React, {useEffect, useState} from 'react';
import Dropdown from '../../cmp/Dropdown';
import {useSelector} from 'react-redux';
import {apiServer, get, getAccessToken} from '../../../api';

function StoreSwitcher() {
    const [sites, setSites] = useState(null)
    const partner_portal_subdomain = useSelector((state)=>state.settings.partner_portal_subdomain)
    useEffect(()=>{
        get(apiServer+'/v1/user/sites',{
                fields:'id, name, logo, affiliate_portal,access_token',
                limit:30,
                offset: 0
        }).then((data) => {
            if(data.sites) {
                setSites(data.sites.map((item) => {
                    return {
                        label: item.name,
                        value: item.affiliate_portal,
                        access_token: item.access_token,
                    }
                }))
            }
        }).catch((e)=>e)
    },[])

    const handleSelection = (value) => {
        const access_token = sites?.find((i)=>i.value === value)?.access_token
        window.location = `${value}/login-as/${access_token || getAccessToken()}`;
    }
    const selected = sites?.find(({value})=>{
        try {
            return new URL(value).hostname === partner_portal_subdomain;
        }catch(e){
            console.log(e)
        }
    })?.value

    return (<>
        {
           sites?.length > 1 &&
                <div id={"store-switcher"} style={{position:'absolute', top:0, right:0}}>
                    <Dropdown opts={sites}
                              selected={selected}
                              onSelected={handleSelection}/>
                </div>
        }
    </>);
}

export default StoreSwitcher
